import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a9d737c86bf030014cd5a4f_1788878503835_6e839024/baroncastle/src/app/about/page.tsx");
